<template>
  <div :class="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm' ? 'mt-5' : 'mt-2'" class="container pt-0">
    <v-app>
      <!-- <div
        id="default-overlay"
        style="
        width: 100%;
        height: 100%;
        background: #000;
        position: fixed;
        z-index: 1;
        opacity: 0;
        display: none;
        top: 0;
        left: 0;"
        @click="closeNav()"
      ></div> -->
      <!-- <div id="mySidenav" class="sidenav">
        <h3 class="h3-header pt-0">On Premise Request</h3>
        <br />
        <p class="text-center">
          Drop us a message and our reps will get back to you.
        </p>
        <v-form @submit.prevent="console.log('Submitted')">
          <v-container>
            <v-row>
              <v-col class="pb-0 pt-0" cols="12" sm="12">
                <v-text-field
                  v-model="formData.name"
                  label="Name"
                  solo
                ></v-text-field>
              </v-col>

              <v-col class="pb-0 pt-0" cols="12" sm="12">
                <v-text-field
                  v-model="formData.phone"
                  label="Phone"
                  solo
                ></v-text-field>
              </v-col>

              <v-col class="pb-0 pt-0" cols="12" sm="12">
                <v-text-field
                  v-model="formData.email"
                  label="Email Address"
                  solo
                ></v-text-field>
              </v-col>

              <v-col class="pb-0 pt-0" cols="12" sm="12">
                <v-select
                  v-model="formData.number_of_users"
                  item-color="#069"
                  :items="usersNumber"
                  label="Number of users in your organisation"
                  solo
                  color="#069"
                  hint="*Number of users in your organization"
                ></v-select>
              </v-col>

              <v-col class="pb-0 pt-0" cols="12" sm="12">
                <v-textarea
                  v-model="formData.address"
                  class="textarea-for-package-type"
                  solo
                  name="input-7-4"
                  label="Address"
                  hint="*Include, State, City and any other important landmarks"
                ></v-textarea>
              </v-col>

              <v-col class="pb-6 pt-0" cols="12" sm="12">
                <v-btn type="submit" x-large dark class="create-submit-package">
                  {{ btnTxt2 }}
                  <v-icon :style="!isLoading ? 'display: none' : ''"
                    >fas fa-circle-notch fa-spin</v-icon
                  >
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </div> -->

      <!-- <h3>Setup your company account</h3>
        <p class="lead text-center">Choose package</p> -->
      <v-form @submit.prevent="auth_request()">
        <v-container>
          <svg
            class="svg-package"
            width="193"
            height="229"
            viewBox="0 0 193 229"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.1"
              d="M0.141847 92.4566C0.141847 93.0506 0.141849 93.6445 0.186556 94.2449C0.429644 100.757 1.1813 107.24 2.43467 113.635C6.09425 132.667 13.7391 151.7 22.7827 169.838C22.9296 170.125 23.0765 170.413 23.217 170.7C23.4341 171.128 23.6449 171.556 23.8557 171.977C24.2814 172.854 24.7242 173.723 25.1841 174.583L26.1868 176.499C26.4231 176.959 26.6722 177.419 26.9149 177.885C27.0618 178.166 27.2151 178.453 27.3747 178.741C29.8739 183.509 32.6131 188.147 35.5816 192.638L35.9201 193.136C39.6426 198.735 44.0067 203.879 48.9234 208.465C57.571 216.416 68.5561 222.164 80.2885 225.447C80.6845 225.562 81.0805 225.664 81.4828 225.773C82.2492 225.97 83.0284 226.162 83.8076 226.347C84.3441 226.475 84.8805 226.596 85.4234 226.705C89.1651 227.508 92.9568 228.056 96.7726 228.346C98.8419 228.506 100.918 228.583 102.98 228.583H103.875C106.425 228.562 108.972 228.413 111.507 228.136L111.871 228.091C118.744 227.355 125.459 225.547 131.772 222.732C132.781 222.281 133.771 221.802 134.741 221.295L135.24 221.04L135.482 220.906C138.734 219.17 141.862 217.213 144.845 215.049C148.326 212.552 151.609 209.844 154.783 207.059C159.521 202.937 164 198.526 168.195 193.852L168.387 193.641C170.188 191.61 171.906 189.524 173.541 187.382V187.344C174.678 185.849 175.768 184.327 176.811 182.777C176.862 182.713 176.906 182.643 176.958 182.566C178.484 180.286 179.902 177.949 181.192 175.541L181.486 174.985C182.418 173.223 183.27 171.43 184.04 169.608C188.46 159.338 190.427 148.219 191.506 137.074C193.71 114.555 192.426 91.3517 186.467 68.8258C185.663 65.7772 184.771 62.7436 183.791 59.7248C183.657 59.3224 183.529 58.9137 183.389 58.5113C183.178 57.8726 182.955 57.234 182.75 56.5634C182.661 56.2951 182.565 56.0205 182.469 55.7522C181.618 53.2998 180.696 50.8622 179.704 48.4395L179.187 47.1621C178.644 45.8848 178.088 44.55 177.507 43.2535C176.977 42.0592 176.427 40.8585 175.853 39.6705C175.757 39.4789 175.667 39.2937 175.578 39.1021C170.66 29.0048 164.21 19.1884 155.038 11.7862C154.4 11.2817 153.761 10.7899 153.122 10.3109C152.164 9.59558 151.174 8.91008 150.153 8.25438L149.431 7.79453L149.163 7.62848L148.971 7.51352L148.862 7.44965C148.345 7.1367 147.815 6.81098 147.285 6.54274C146.755 6.2745 146.199 5.96794 145.65 5.69331H145.573L145.356 5.59113C144.928 5.37398 144.494 5.1696 144.079 4.95246L143.632 4.75447L143.459 4.67783L142.738 4.37765C139.461 3.00665 136.048 1.9855 132.557 1.3312C130.624 0.970674 128.67 0.731767 126.707 0.615888C123.733 0.432833 120.748 0.593564 117.81 1.09489C117.363 1.17153 116.923 1.25456 116.482 1.35036C112.769 2.10394 109.256 3.62687 106.167 5.82105C102.15 8.73338 99.3145 12.6357 96.7406 16.6784L96.4788 17.0872C96.0445 17.7706 95.623 18.4539 95.2015 19.1373C93.7261 21.5259 92.2508 23.9273 90.6924 26.284C89.249 28.4683 87.7354 30.6142 86.1004 32.6707C84.4565 34.7444 82.6634 36.6954 80.7356 38.5082C80.4482 38.7764 80.1544 39.0446 79.8542 39.3065C76.3012 42.47 72.2111 44.9725 67.777 46.6959C63.7661 48.1968 59.4743 48.8738 55.3037 48.0052C54.122 47.7644 52.9699 47.3961 51.8677 46.9067C49.7856 45.987 47.7483 45.0865 45.7429 44.2881C42.1636 42.747 38.4007 41.6737 34.547 41.0948C30.5652 40.562 26.5137 41.0003 22.738 42.3721C22.0993 42.5957 21.4926 42.8511 20.8603 43.1321C18.0736 44.372 15.5202 46.0808 13.3112 48.184C13.0494 48.4331 12.7939 48.6886 12.5384 48.944C6.95007 54.6537 3.87168 62.5541 2.21752 70.282C0.677233 77.5694 -0.0192417 85.0099 0.141847 92.4566Z"
              fill="#069"
            />
          </svg>
          <v-row>
            <v-col md="8" lg="8" offset-md="2" offset-lg="2">
              <v-radio-group v-model="picked">
                <v-row :style="feature.header.toLowerCase() == 'on premise' ? 'display: none !important;' : 'color: #00f;'" v-for="feature in features" :key="feature.id">
                  <!-- {{ feature.header }} -->
                  <v-col md="1" lg="1" cols="1" class="my-auto">
                    <v-radio
                      :value="feature.header"
                      color="#069"
                      @click="
                        picked.toLowerCase() === 'on premise' ? openNav() : ''
                      "
                    ></v-radio>
                  </v-col>
                  <v-col md="10" lg="10" cols="10">
                    <v-card
                      v-if="
                        picked.toLowerCase() === 'on premise' &&
                          feature.header.toLowerCase() === 'on premise'
                      "
                      @click.prevent="
                        picked.toLowerCase() === 'on premise' &&
                        feature.header.toLowerCase() === 'on premise'
                          ? openNav()
                          : ''
                      "
                      class="feature-card py-5"
                      :style="
                        picked.toLowerCase() === 'on premise' &&
                        feature.header.toLowerCase() === 'on premise'
                          ? 'cursor: pointer !important;'
                          : 'cursor: default !important;'
                      "
                    >
                      <v-row>
                        <v-col class="text-center pt-0 pb-0 my-auto" md="4">
                          <v-icon class="my-auto" x-large color="#069">
                            {{ feature.icon }}
                          </v-icon>
                        </v-col>
                        <v-col md="7" lg="7" cols="12" class="pt-0 pb-0">
                          <h3
                            :class="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm' ? 'text-center' : 'text-left'"
                            class="card-h3"
                            style="margin-top: 20px;"
                          >
                            {{ feature.header }}
                          </h3>
                          <p 
                          :class="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm' ? 'text-center mx-2' : 'text-left'"
                          class="card-p">{{ feature.paragraph }}</p>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-card
                      v-else
                      class="feature-card py-5"
                      :style="
                        picked.toLowerCase() === 'on premise' &&
                        feature.header.toLowerCase() === 'on premise'
                          ? 'cursor: pointer !important;'
                          : 'cursor: default !important;'
                      "
                    >
                      <v-row>
                        <v-col class="text-center pt-0 pb-0 my-auto" md="4">
                          <v-icon class="my-auto" x-large color="#069">
                            {{ feature.icon }}
                          </v-icon>
                        </v-col>
                        <v-col md="7" lg="7" cols="12" class="pt-0 pb-0">
                          <h3
                            :class="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm' ? 'text-center' : 'text-left'"
                            class="card-h3"
                            style="margin-top: 20px;"
                          >
                            {{ feature.header }}
                          </h3>
                          <p 
                          :class="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm' ? 'text-center mx-2' : 'text-left'"
                          class="card-p">{{ feature.paragraph }}</p>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-radio-group>
            </v-col>

            <v-row>
              <v-col class="pb-6 text-right" cols="6" sm="6">
                <v-btn
                  type="submit"
                  x-large
                  dark
                  class="create-submit"
                  :class="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm' ? 'w-100' : null"
                  @click="goBack(1)"
                >
                  Previous
                  <v-icon :style="!isLoading ? 'display: none' : ''"
                    >fas fa-circle-notch fa-spin</v-icon
                  >
                </v-btn>
              </v-col>
              <v-col class="pb-6 text-left" cols="6" sm="6">
                <v-btn
                  type="submit"
                  x-large
                  dark
                  class="create-submit"
                  :class="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm' ? 'w-100' : null"
                  @click="changeStep(3)"
                >
                  {{ btnTxt }}
                  <v-icon :style="!isLoading ? 'display: none' : ''"
                    >fas fa-circle-notch fa-spin</v-icon
                  >
                </v-btn>
              </v-col>
            </v-row>

          </v-row>
        </v-container>
      </v-form>

      <div class="text-center">
        <v-dialog v-model="chooseOne" width="500">
          <v-card>
            <v-card-text class="pt-5">
              <div class="col-md-8 mx-auto text-center pb-5">
                <img
                  src="@/assets/graphics/attention.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <h3 class="msg pl-5 pr-5 text-center" style="display: block;">
                Please select an option
              </h3>
            </v-card-text>

            <v-divider class="mb-0"></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#069" text @click="chooseOne = false">
                <strong>Close</strong>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-app>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chooseOne: false,
      isLoading: false,
      btnTxt: "Next",
      picked: "Online",
      features: [
        {
          id: 1,
          icon: "mdi-cloud-off-outline",
          header: "On Premise",
          paragraph:
            "The platform will be setup to work only within a specified location. e.g The office.",
          checked: false
        },
        {
          id: 2,
          icon: "mdi-cast-connected",
          header: "Online",
          paragraph:
            "The platform works online and can be accessed anywhere with an internet connection.",
          checked: false
        }
      ],
      drawer: null,
      items: [
        { title: "Home", icon: "mdi-home-city" },
        { title: "My Account", icon: "mdi-account" },
        { title: "Users", icon: "mdi-account-group-outline" }
      ],
      formData: {
        name: "",
        phone: "",
        email: "",
        number_of_users: "",
        address: ""
      },
      usersNumber: [
        "1 - 9",
        "10 - 19",
        "20 - 29",
        "30 - 39",
        "40 - 49",
        "50 - above"
      ],
      show: false,
      btnTxt2: "Submit"
    };
  },
  methods: {
    openNav() {
      if (screen.width > 450) {
        document.getElementById("mySidenav").style.width = "40%";
        document.getElementById("mySidenav").style.paddingLeft = "30px";
        document.getElementById("mySidenav").style.paddingRight = "30px";
        document.getElementById("default-overlay").style.opacity = "0.1";
        document.getElementById("default-overlay").style.display = "block";
      } else {
        document.getElementById("mySidenav").style.width = "80%";
        document.getElementById("default-overlay").style.opacity = "0.1";
        document.getElementById("default-overlay").style.display = "block";
      }
    },
    closeNav() {
      console.log("close");
      document.getElementById("mySidenav").style.width = "0";
      document.getElementById("mySidenav").style.paddingLeft = "0px";
      document.getElementById("mySidenav").style.paddingRight = "0px";
      document.getElementById("default-overlay").style.opacity = "0";
      document.getElementById("default-overlay").style.display = "none";
    },
    goBack(step) {
      this.$emit("goBack", {
        step
      })
    },
    changeStep(step) {
      let _this = this;
      if (this.picked !== "") {
        this.$emit("packageStep", {
          step,
          pick: _this.picked
        });
      } else {
        this.chooseOne = true;
      }
    },
    auth_request() {
      //
    }
    // changeStep (step) {
    //     this.$emit('step', step);
    // }
  }
};
</script>

<style lang="scss">
@media (max-width: 991px) {
  .create-submit {
    height: 45px !important;
  }
  .feature-card div div .mdi {
    font-size: 60px !important;
  }
}
$primary-color: #069;
$text-field-color: #4e4e52;

.fa-eye,
.fa-eyeslash {
  color: $primary-color !important;
}

.company-name .v-text-field--single-line {
  .v-text-field__suffix,
  .v-text-field__prefix {
    color: $text-field-color !important;
    background-color: #00669914;
    padding: 10px;
    height: 38px;
  }
}

// .v-text-field__suffix, .v-text-field__prefix, input {
//     color: $text-field-color !important;
//     background-color: #00669914;
//     padding: 10px;
//     height: 48px;
// }
.v-text-field__suffix {
  border-radius: 0px 5px 5px 0px;
  padding-top: 8px;
  padding-left: 8px !important;
}
.v-text-field__prefix {
  border-radius: 5px 0px 0px 5px;
  padding-top: 8px;
  padding-right: 8px !important;
  text-decoration: underline;
}
.company-name .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) {
  label {
    margin-left: 2%;
  }
  input {
    text-indent: 3%;
  }
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: 0px 0px 50px 0px #00000014 !important;
}
.v-text-field__details {
  padding-left: 0 !important;
}
.theme--light.v-messages {
  color: $primary-color !important;
}
.company-name
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  padding: 0px !important;
}
h3 {
  font-family: Work Sans;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: -0.6252632141113281px;
  text-align: center;
  color: #111d5e;
}
label {
  color: #999 !important;
}
</style>
<style lang="scss" scoped>
.textarea-for-package-type div div {
  padding-right: 0px !important;
}
.create-submit-package {
  width: 100%;
  height: 60px !important;
  border-radius: 10px !important;
  background-color: #069 !important;
  text-transform: initial !important;
  font-weight: 600 !important;
  span {
    text-transform: initial !important;
  }
}
.h3-header {
  font-size: 20px !important;
}
.sidenav {
  height: 100%;
  width: 0px;
  position: fixed;
  z-index: 1;
  top: 0;
  right: 0;
  background-color: #fff;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
  padding-right: 0;
  padding-left: 0;
}

.sidenav a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #000000;
  display: block;
  transition: 0.3s;
}

@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }
  .sidenav a {
    font-size: 18px;
  }
}

.svg-package {
  position: absolute;
  right: 30%;
}
i.fas {
  padding: 20px 0px;
}
.v-input--radio-group--column .v-input--radio-group__input {
  flex-direction: initial !important;
}
.v-form {
  margin: 0%;
}
$primary-color: #069;
#small-link {
  color: $primary-color !important;
}
.space-top {
  padding-top: 20px;
}
.create-submit {
  width: 35%;
  height: 60px;
  border-radius: 10px !important;
  background-color: #069 !important;
  text-transform: initial !important;
  font-weight: 600;
  span {
    text-transform: initial;
  }
}
.lead {
  margin-bottom: 0;
  padding: 2% 0 0 0;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: -0.6252632141113281px;
  text-align: left;
}
.card-h3 {
  font-size: 17px;
  margin-top: 10px;
}
.card-p {
  font-size: 13px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0px;
  text-align: left;
  color: #111d5e !important;
}
.feature-card div div .mdi {
  font-size: 100px !important;
}
.feature-card {
  box-shadow: 0px 0px 50px 0px #00000014 !important;
  border-radius: 10px !important;
  border: 1px solid #fff;
}
.v-input--selection-controls {
  margin-top: 0px !important;
}
.v-messages {
  display: none !important;
}
.right-card {
  padding: 60px 0px;
  box-shadow: 0px 0px 50px 0px #00000014 !important;
  border-radius: 10px !important;
}
.mdi-progress-question {
  bottom: 1px;
}
</style>
